import React from 'react';

import { IAffiliateCtaFields } from '../../../../types/contentful';

import { getImageData } from '../../../utils/contentful';

import { GlImage } from '../../Image';
import { GlLink } from '../../Link';

const DEFAULT_WIDTH = 156;
const pxToRem = (px: number) => `${px / 16}rem`;

export interface AffiliateCtaProps extends IAffiliateCtaFields {
  height?: string | number;
}

export function AffiliateCta({
  buttonUrl,
  image,
  mobileWidth,
  desktopWidth,
  height
}: AffiliateCtaProps) {
  const { width, ...imgData } = getImageData(image);
  const baseWidth = width ?? DEFAULT_WIDTH;
  const baseHeight =
    typeof height === 'string'
      ? height
      : height != null
      ? pxToRem(height as number)
      : '100%';
  const baseW = pxToRem(baseWidth);
  const mobileW = pxToRem(mobileWidth ?? baseWidth);
  const desktopW = pxToRem(desktopWidth ?? baseWidth);

  return (
    <div className="flex flex-col justify-center">
      <GlLink
        href={buttonUrl ?? 'https://greenlight.com'}
        data-testid="affiliate-cta"
        data-width={width ?? DEFAULT_WIDTH}
        className="inline-block h-[var(--affiliate-height)] w-[var(--affiliate-w)] max-w-[14.375rem] overflow-visible small:w-[var(--affiliate-mobile-w)] small:max-w-none tablet:w-[var(--affiliate-desktop-w)]"
        style={
          {
            '--affiliate-height': baseHeight,
            '--affiliate-w': baseW,
            '--affiliate-mobile-w': mobileW,
            '--affiliate-desktop-w': desktopW
          } as React.CSSProperties
        }
      >
        <GlImage {...imgData} width={width ?? DEFAULT_WIDTH} />
      </GlLink>
    </div>
  );
}
